import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PersonalSiteComponent } from './personal-site.component';
import { PersonalSiteResolver } from './personal-site.resolver';
import { MobileServicesResolver } from '../mobile-services/mobile-services.resolver';

const routes: Routes = [
  {
    path: '',
    component: PersonalSiteComponent,
    resolve: { user: PersonalSiteResolver, services: MobileServicesResolver },
    data: {
      cookieDisclaimer: true,
      setMetaByDefault: false,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PersonalSiteRoutingModule {}
